import { render, staticRenderFns } from "./Redes.vue?vue&type=template&id=228c0cbc&"
import script from "./Redes.vue?vue&type=script&lang=js&"
export * from "./Redes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports